// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.city-selection-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 9999;
  font-family: "Cinzel", "Palatino Linotype", serif;
}

.city-selection-panel {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: city-panel-in 0.25s ease-out;
}
.city-selection-panel__frame {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.city-selection-panel__content {
  position: absolute;
  top: 56px;
  left: 56px;
  right: 56px;
  bottom: 56px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@keyframes city-panel-in {
  from {
    opacity: 0;
    transform: translate(-50%, -46%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
.city-selection-header {
  display: flex;
  align-items: flex-end;
  height: 64px;
  margin-bottom: 1rem;
  pointer-events: none;
  user-select: none;
}
.city-selection-header .header-edge {
  width: 64px;
  height: 64px;
  flex-shrink: 0;
}
.city-selection-header .header-edge--right {
  transform: scaleX(-1);
}
.city-selection-header .header-mid {
  flex: 1;
  height: 64px;
  object-fit: fill;
  min-width: 0;
}

.city-selection-title {
  text-align: center;
  color: #c8c4bc;
  font-size: clamp(0.75rem, 1.4vw, 1rem);
  font-weight: 400;
  letter-spacing: 0.35em;
  text-transform: uppercase;
  margin: 0 0 1.2rem;
}

.city-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  gap: 0.4rem 0.2rem;
}
.city-grid .city-item {
  flex: 0 0 calc(20% - 0.2rem);
}
@media (max-width: 700px) {
  .city-grid .city-item {
    flex: 0 0 calc(33.33% - 0.2rem);
  }
}
@media (max-width: 420px) {
  .city-grid .city-item {
    flex: 0 0 calc(50% - 0.2rem);
  }
}

.city-item {
  background: none;
  border: none;
  padding: 0.2rem 0.25rem 0.3rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.55rem;
  transition: transform 0.15s;
}
.city-item:hover, .city-item--hovered {
  transform: translateY(-4px);
}
.city-item:hover .shield-svg path:first-child, .city-item--hovered .shield-svg path:first-child {
  stroke-opacity: 1;
}
.city-item:hover .shield-svg path, .city-item:hover .shield-svg line, .city-item--hovered .shield-svg path, .city-item--hovered .shield-svg line {
  opacity: 1;
}
.city-item:hover .city-item-name, .city-item--hovered .city-item-name {
  color: #fff;
}
.city-item:focus {
  outline: none;
}

.city-shield {
  width: 100%;
  max-width: 126px;
}

.shield-svg {
  width: 100%;
  height: auto;
  display: block;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.6));
  transition: filter 0.15s;
}
.shield-svg path, .shield-svg line {
  transition: opacity 0.15s, stroke-opacity 0.15s;
}
.city-item:hover .shield-svg {
  filter: drop-shadow(0 4px 18px rgba(0, 0, 0, 0.8)) brightness(1.3);
}

.blason-emblem {
  position: relative;
  width: 100%;
  aspect-ratio: 100/120;
  display: flex;
  align-items: center;
  justify-content: center;
}
.blason-emblem .shield-svg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.blason-emblem__mark {
  position: relative;
  width: 84%;
  max-height: 72%;
  object-fit: contain;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5));
  transition: filter 0.15s;
  z-index: 1;
}
.city-item:hover .blason-emblem .blason-emblem__mark {
  filter: brightness(1.2);
}

.shield-img {
  width: 100%;
  aspect-ratio: 100/120;
  display: block;
  object-fit: cover;
  object-position: center 15%;
  clip-path: polygon(0% 4%, 100% 4%, 100% 58%, 75% 80%, 50% 100%, 25% 80%, 0% 58%);
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.6));
  transition: filter 0.15s;
}
.city-item:hover .shield-img {
  filter: drop-shadow(0 4px 18px rgba(0, 0, 0, 0.8)) brightness(1.15);
}

.city-item-name {
  color: #9d9e9e;
  font-size: clamp(0.6rem, 1vw, 0.72rem);
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  text-align: center;
  transition: color 0.15s;
  line-height: 1.3;
}

.city-item-hold {
  color: #a8a49a;
  font-size: 0.55rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  text-align: center;
}

.city-tooltip {
  margin-top: 0.6rem;
  text-align: center;
  color: #cfcbc2;
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  font-style: italic;
  font-size: 0.95rem;
  line-height: 1.5;
  min-height: 1.8rem;
  opacity: 0;
  transition: opacity 0.2s;
  padding: 0 2rem;
}
.city-tooltip--visible {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/CitySelection/CitySelection.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,iDAAA;AAAF;;AAOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uCAAA;AAJF;AAME;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAJJ;AAOE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AALJ;;AASA;EACE;IAAO,UAAA;IAAY,gCAAA;EAJnB;EAKA;IAAO,UAAA;IAAY,gCAAA;EADnB;AACF;AAGA;EACE,aAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AADF;AAGE;EAAsB,WAAA;EAAa,YAAA;EAAc,cAAA;AAEnD;AADE;EAAsB,qBAAA;AAIxB;AAHE;EAAsB,OAAA;EAAS,YAAA;EAAc,gBAAA;EAAkB,YAAA;AASjE;;AANA;EACE,kBAAA;EACA,cAAA;EACA,sCAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AASF;;AALA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;AAQF;AANE;EACE,4BAAA;AAQJ;AALE;EAA4B;IAAa,+BAAA;EASzC;AACF;AATE;EAA4B;IAAa,4BAAA;EAazC;AACF;;AAVA;EACE,gBAAA;EACA,YAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;AAaF;AAXE;EAEE,2BAAA;AAYJ;AAVI;EACE,iBAAA;AAYN;AAVI;EACE,UAAA;AAYN;AAVI;EAAkB,WAAA;AAatB;AAVE;EAAU,aAAA;AAaZ;;AAVA;EACE,WAAA;EACA,gBAAA;AAaF;;AAVA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kDAAA;EACA,wBAAA;AAaF;AAXE;EAAa,+CAAA;AAcf;AAZE;EACE,kEAAA;AAcJ;;AARA;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAWF;AATE;EAAc,kBAAA;EAAoB,QAAA;EAAU,WAAA;EAAa,YAAA;AAe3D;AAVE;EACE,kBAAA;EACA,UAAA;EACA,eAAA;EACA,mBAAA;EACA,iDAAA;EACA,wBAAA;EACA,UAAA;AAYJ;AATE;EAA0C,uBAAA;AAY5C;;AATA;EACE,WAAA;EACA,qBAAA;EACA,cAAA;EACA,iBAAA;EACA,2BAAA;EAEA,gFAAA;EACA,kDAAA;EACA,wBAAA;AAWF;AAVE;EAAqB,mEAAA;AAavB;;AAVA;EACE,cAAA;EACA,sCAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;AAaF;;AAVA;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAaF;;AATA;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,iEAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,eAAA;AAYF;AAVE;EAAa,UAAA;AAaf","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600&display=swap');\r\n\r\n.city-selection-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.90);\r\n  z-index: 9999;\r\n  font-family: 'Cinzel', 'Palatino Linotype', serif;\r\n}\r\n\r\n// ── Panel — same proven pattern as AuthPanel ──────────────────\r\n// Fixed px size, centred with a transform (NOT flex), so it can never be\r\n// stretched. The real SkyrimFrame component is drawn behind at the exact\r\n// same dimensions; content sits in an inset absolute layer on top.\r\n.city-selection-panel {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  animation: city-panel-in 0.25s ease-out;\r\n\r\n  &__frame {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 0;\r\n  }\r\n\r\n  &__content {\r\n    position: absolute;\r\n    top: 56px;\r\n    left: 56px;\r\n    right: 56px;\r\n    bottom: 56px;\r\n    z-index: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n@keyframes city-panel-in {\r\n  from { opacity: 0; transform: translate(-50%, -46%); }\r\n  to   { opacity: 1; transform: translate(-50%, -50%); }\r\n}\r\n\r\n.city-selection-header {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  height: 64px;\r\n  margin-bottom: 1rem;\r\n  pointer-events: none;\r\n  user-select: none;\r\n\r\n  .header-edge        { width: 64px; height: 64px; flex-shrink: 0; }\r\n  .header-edge--right { transform: scaleX(-1); }\r\n  .header-mid         { flex: 1; height: 64px; object-fit: fill; min-width: 0; }\r\n}\r\n\r\n.city-selection-title {\r\n  text-align: center;\r\n  color: #c8c4bc;\r\n  font-size: clamp(0.75rem, 1.4vw, 1rem);\r\n  font-weight: 400;\r\n  letter-spacing: 0.35em;\r\n  text-transform: uppercase;\r\n  margin: 0 0 1.2rem;\r\n}\r\n\r\n// ── Blason grid ───────────────────────────────────────────────\r\n.city-grid {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n  align-content: flex-start;\r\n  gap: 0.4rem 0.2rem;\r\n\r\n  .city-item {\r\n    flex: 0 0 calc(20% - 0.2rem);\r\n  }\r\n\r\n  @media (max-width: 700px) { .city-item { flex: 0 0 calc(33.33% - 0.2rem); } }\r\n  @media (max-width: 420px) { .city-item { flex: 0 0 calc(50% - 0.2rem); } }\r\n}\r\n\r\n// ── Individual blason item ────────────────────────────────────\r\n.city-item {\r\n  background: none;\r\n  border: none;\r\n  padding: 0.2rem 0.25rem 0.3rem;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 0.55rem;\r\n  transition: transform 0.15s;\r\n\r\n  &:hover,\r\n  &--hovered {\r\n    transform: translateY(-4px);\r\n\r\n    .shield-svg path:first-child {\r\n      stroke-opacity: 1;\r\n    }\r\n    .shield-svg path, .shield-svg line {\r\n      opacity: 1;\r\n    }\r\n    .city-item-name { color: #fff; }\r\n  }\r\n\r\n  &:focus { outline: none; }\r\n}\r\n\r\n.city-shield {\r\n  width: 100%;\r\n  max-width: 126px; // 72px * 1.75\r\n}\r\n\r\n.shield-svg {\r\n  width: 100%;\r\n  height: auto;\r\n  display: block;\r\n  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.6));\r\n  transition: filter 0.15s;\r\n\r\n  path, line { transition: opacity 0.15s, stroke-opacity 0.15s; }\r\n\r\n  .city-item:hover & {\r\n    filter: drop-shadow(0 4px 18px rgba(0,0,0,0.8)) brightness(1.3);\r\n  }\r\n}\r\n\r\n// Emblem blason: heater shield + a solid-colour mark masked by a PNG artwork\r\n// (see WhiterunEmblem). The mark sits inside the shield's inner border.\r\n.blason-emblem {\r\n  position: relative;\r\n  width: 100%;\r\n  aspect-ratio: 100 / 120;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  .shield-svg { position: absolute; inset: 0; width: 100%; height: 100%; }\r\n\r\n  // Plain flex-centered sizing — no top/left/right/bottom combined with an\r\n  // explicit width/height (that was over-constraining the box and collapsing\r\n  // it in this CEF build).\r\n  &__mark {\r\n    position: relative;\r\n    width: 84%;\r\n    max-height: 72%;\r\n    object-fit: contain;\r\n    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.5));\r\n    transition: filter 0.15s;\r\n    z-index: 1;\r\n  }\r\n\r\n  .city-item:hover & .blason-emblem__mark { filter: brightness(1.2); }\r\n}\r\n\r\n.shield-img {\r\n  width: 100%;\r\n  aspect-ratio: 100 / 120;\r\n  display: block;\r\n  object-fit: cover;\r\n  object-position: center 15%;\r\n  // Same heater-shield shape as the SVG placeholder, in % so it scales with the image\r\n  clip-path: polygon(0% 4%, 100% 4%, 100% 58%, 75% 80%, 50% 100%, 25% 80%, 0% 58%);\r\n  filter: drop-shadow(0 4px 12px rgba(0,0,0,0.6));\r\n  transition: filter 0.15s;\r\n  .city-item:hover & { filter: drop-shadow(0 4px 18px rgba(0,0,0,0.8)) brightness(1.15); }\r\n}\r\n\r\n.city-item-name {\r\n  color: #9d9e9e;\r\n  font-size: clamp(0.6rem, 1vw, 0.72rem);\r\n  font-weight: 600;\r\n  letter-spacing: 0.2em;\r\n  text-transform: uppercase;\r\n  text-align: center;\r\n  transition: color 0.15s;\r\n  line-height: 1.3;\r\n}\r\n\r\n.city-item-hold {\r\n  color: #a8a49a;\r\n  font-size: 0.55rem;\r\n  letter-spacing: 0.18em;\r\n  text-transform: uppercase;\r\n  text-align: center;\r\n}\r\n\r\n// ── Tooltip description (bottom, shared) ──────────────────────\r\n.city-tooltip {\r\n  margin-top: 0.6rem;\r\n  text-align: center;\r\n  color: #cfcbc2;\r\n  font-family: 'Palatino Linotype', 'Book Antiqua', Palatino, serif;\r\n  font-style: italic;\r\n  font-size: 0.95rem;\r\n  line-height: 1.5;\r\n  min-height: 1.8rem;\r\n  opacity: 0;\r\n  transition: opacity 0.2s;\r\n  padding: 0 2rem;\r\n\r\n  &--visible { opacity: 1; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
